(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('tcp-split-hero')) return;

    class TCPSplitHero extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.controller?.abort();
        this.stop();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('.tcp-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-index]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Math.max(2000, Number(this.dataset.interval) || 5000);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (this.slides.length < 2) return;
        const controls = this.querySelector('.tcp-hero__controls');
        if (controls) controls.hidden = false;

        this.addEventListener('click', (event) => {
          const control = event.target.closest('button');
          if (!control || !this.contains(control)) return;
          if (control.hasAttribute('data-toggle')) {
            this.paused = !this.paused;
            this.toggle.textContent = this.paused ? 'Reanudar banners' : 'Pausar banners';
            this.schedule();
          } else if (control.hasAttribute('data-prev')) {
            this.show(this.index - 1, true);
          } else if (control.hasAttribute('data-next')) {
            this.show(this.index + 1, true);
          } else if (control.hasAttribute('data-index')) {
            this.show(Number(control.dataset.index), true);
          }
        }, options);

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.schedule();
        }, options);
        this.addEventListener('focusout', () => {
          clearTimeout(this.focusTimer);
          this.focusTimer = setTimeout(() => {
            this.focused = this.contains(document.activeElement);
            this.schedule();
          }, 0);
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);

        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
          if (selected >= 0) this.show(selected, false);
        }, options);

        this.show(0, false);
      }

      show(index, announce) {
        if (!Number.isFinite(index) || !this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          const active = position === this.index;
          slide.hidden = !active;
          slide.toggleAttribute('inert', !active);
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === this.index)));
        if (announce && this.status) this.status.textContent = `Banner ${this.index + 1} de ${this.slides.length}`;
        this.schedule();
      }

      stop() {
        clearTimeout(this.timer);
        this.timer = null;
      }

      schedule() {
        this.stop();
        if (!this.isConnected || !this.autoplay || this.paused || this.hovered || this.focused || document.hidden || this.motion.matches || window.Shopify?.designMode) return;
        if (this.slides.length < 2) return;
        this.timer = setTimeout(() => this.show(this.index + 1, false), this.interval);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.focusTimer);
        this.stop();
        this.controller?.abort();
      }
    }
    customElements.define('tcp-split-hero', TCPSplitHero);
  })();

  } catch(e) { console.error(e); }
})();
})();
